<template>
  <div class="site-header-wrapper">
    <header class="site-header">
      <div class="site-logo">{{ siteTitle }}</div>
      <nav class="main-nav">
        <span v-for="item in normalizedNavItems" :key="item.label" class="main-nav-item">
          <router-link v-if="item.route" :to="item.route">{{ item.label }}</router-link>
          <span v-else>{{ item.label }}</span>
        </span>
      </nav>
      <div class="search-panel">
        <div class="search-bar">
          <input
            type="text"
            class="search-input"
            :placeholder="searchPlaceholder"
            aria-label="站内搜索"
          />
          <img :src="images.searchIcon" alt="搜索" />
        </div>
      </div>
      <button
        class="mobile-menu-toggle"
        :class="{ 'mobile-menu-toggle--open': isMobileMenuOpen }"
        type="button"
        @click="toggleMobileMenu"
        :aria-label="isMobileMenuOpen ? '关闭菜单' : '展开菜单'"
        :aria-expanded="isMobileMenuOpen.toString()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>

    <div
      class="mobile-menu-mask"
      :class="{ 'mobile-menu-mask--visible': isMobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>

    <section
      class="mobile-menu-panel"
      :class="{ 'mobile-menu-panel--open': isMobileMenuOpen }"
    >
      <div class="mobile-menu__header">
        <div class="mobile-menu__title">{{ siteTitle }}</div>
        <button class="mobile-menu__close" type="button" @click="closeMobileMenu" aria-label="关闭菜单">×</button>
      </div>
      <div class="mobile-menu__search">
        <input type="text" :placeholder="searchPlaceholder" aria-label="站内搜索" />
        <button type="button" aria-label="执行搜索">
          <img :src="images.searchIcon" alt="" />
        </button>
      </div>
      <nav class="mobile-menu__nav">
        <button
          v-for="item in normalizedNavItems"
          :key="`mobile-${item.label}`"
          type="button"
          class="mobile-menu__nav-item"
          @click="handleMobileNavClick(item)"
        >
          <span>{{ item.label }}</span>
          <img :src="images.arrowIcon" alt="" />
        </button>
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    siteTitle: {
      type: String,
      default: '新闻所历史（暂定）'
    },
    navItems: {
      type: Array,
      default: () => [
        { label: '领导关怀', route: '/lanhu_jigouyulishi' },
        { label: '建制沿革', route: { path: '/lanhu_jigouyulishi', query: { item: 'evolution-history', subitem: 'name-change' } } },
        { label: '学科建设', route: '/lanhu_xuekeyukeyan' },
        { label: '创新工程', route: '/lanhu_chuangxingongcheng' },
        { label: '传播平台', route: '/lanhu_chuanboyupingtai' }
      ]
    },
    searchPlaceholder: {
      type: String,
      default: '搜索...'
    }
  },
  data() {
    return {
      isMobileMenuOpen: false,
      images: {
        searchIcon: require('@/views/lanhu_shouye/assets/img/SketchPng48d84935d5a015c26c4b72f169e3d80d468628f4f9241b15f60cd40c9d2d3759.png'),
        arrowIcon: require('@/views/lanhu_shouye/assets/img/SketchPng72895929e9819fcf2124c82845d59a576118c9b4c94b94e6940eb31665ba5704.png')
      }
    };
  },
  watch: {
    isMobileMenuOpen(isOpen) {
      if (typeof document === 'undefined') {
        return;
      }
      document.body.style.overflow = isOpen ? 'hidden' : '';
      document.body.style.touchAction = isOpen ? 'none' : '';
    }
  },
  computed: {
    normalizedNavItems() {
      const routeMap = {
        领导关怀: '/lanhu_jigouyulishi',
        建制沿革: { path: '/lanhu_jigouyulishi', query: { item: 'evolution-history', subitem: 'name-change' } },
        学科建设: '/lanhu_xuekeyukeyan',
        创新工程: '/lanhu_chuangxingongcheng',
        传播平台: '/lanhu_chuanboyupingtai'
      };
      return this.navItems.map((item) => {
        if (item && typeof item === 'object' && 'label' in item) {
          if (!item.route && routeMap[item.label]) {
            return { ...item, route: routeMap[item.label] };
          }
          return item;
        }
        if (routeMap[item]) {
          return { label: item, route: routeMap[item] };
        }
        return { label: item };
      });
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  },
  methods: {
    toggleMobileMenu() {
      const willOpen = !this.isMobileMenuOpen;
      if (willOpen) {
        this.isMobileMenuOpen = true;
      } else {
        this.closeMobileMenu();
      }
    },
    handleMobileNavClick(item) {
      if (!item || !item.route) {
        return;
      }
      this.$router.push(item.route);
      this.closeMobileMenu();
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    handleResize() {
      if (typeof window === 'undefined') {
        return;
      }
      if (window.innerWidth > 1024 && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    }
  }
};
</script>

<style scoped>
.site-header-wrapper {
  position: relative;
}

.site-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  background-color: #9c1e23;
  padding: 36px clamp(40px, 8vw, 120px) 34px;
  color: #fff;
  column-gap: 40px;
  position: relative;
  overflow: hidden;
}

.site-header::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: clamp(30px, 6vw, 120px);
  height: 100%;
  aspect-ratio: 307 / 122;
  width: auto;
  min-width: 360px;
  max-width: 720px;
  background: url('~@/views/lanhu_shouye/assets/img/SketchPng7a3e25de6431990d079ffcde2fe49e63178d6b3d3c219dbf4a6416bd92f4676f.png')
    no-repeat right center / auto 100%;
  opacity: 0.6;
  pointer-events: none;
  z-index: 0;
}

.site-header > * {
  position: relative;
  z-index: 1;
}

.site-logo {
  font-size: 34px;
  font-family: 'SourceHanSerifCN-SemiBold', 'STSongti-SC-Bold', serif;
  letter-spacing: 0.45px;
  white-space: nowrap;
}

.main-nav {
  display: flex;
  gap: 32px;
  font-size: 20px;
  font-family: 'STSongti-SC-Bold', 'SourceHanSerifCN-SemiBold', serif;
  align-items: center;
  white-space: nowrap;
  justify-self: end;
  align-self: flex-end;
  padding-bottom: 2px;
  position: relative;
  z-index: 2;
}

.main-nav span {
  white-space: nowrap;
}

.main-nav a {
  color: inherit;
  text-decoration: none;
}

.search-panel {
  position: absolute;
  top: 30px;
  right: clamp(20px, 8vw, 140px);
  width: clamp(220px, 26vw, 320px);
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 30px;
  box-sizing: border-box;
  align-items: flex-end;
  pointer-events: auto;
  z-index: 1;
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(253, 200, 200, 0.95);
  border-radius: 28px;
  border: 1px solid rgba(212, 137, 90, 0.85);
  color: #593629;
  font-size: 16px;
  padding: 4px 70px 4px 14px;
  width: 220px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
  margin-top: -20px;
}

.search-bar::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 43px;
  background-color: #8b1e24;
  z-index: 0;
}

.search-bar::before {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  width: 18px;
  height: 18px;
  background: url('~@/views/lanhu_shouye/assets/img/SketchPng48d84935d5a015c26c4b72f169e3d80d468628f4f9241b15f60cd40c9d2d3759.png')
    no-repeat center / contain;
  transform: translateY(-50%);
  z-index: 1;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  color: #3f2d22;
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  position: relative;
  z-index: 1;
}

.search-input::placeholder {
  color: rgba(63, 45, 34, 0.65);
}

.search-input:focus {
  outline: none;
}

.search-bar img {
  display: none;
}

.mobile-menu-toggle {
  display: none;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-direction: column;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  transition: background-color 0.3s ease;
}

.mobile-menu-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: currentColor;
  border-radius: 1px;
  transition: transform 0.35s cubic-bezier(0.4, 0.14, 0.3, 1.4), opacity 0.2s ease;
  transform-origin: center;
}

.mobile-menu-toggle--open {
  background: rgba(255, 255, 255, 0.18);
}

.mobile-menu-toggle--open span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-menu-toggle--open span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0.3);
}

.mobile-menu-toggle--open span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.mobile-menu-mask {
  position: fixed;
  inset: 0;
  background: rgba(10, 7, 7, 0.52);
  opacity: 0;
  transition: opacity 0.26s ease;
  pointer-events: none;
  z-index: 1000;
}

.mobile-menu-mask--visible {
  opacity: 1;
  pointer-events: auto;
}

.mobile-menu-panel {
  position: fixed;
  inset: 0 0 0 auto;
  width: 86vw;
  max-width: 360px;
  background: linear-gradient(180deg, rgba(156, 30, 35, 0.98) 0%, rgba(135, 20, 28, 0.99) 100%);
  padding: 32px 28px 48px;
  box-sizing: border-box;
  color: #fff;
  z-index: 1100;
  transform: translate3d(104%, 0, 0);
  opacity: 0;
  transition: transform 0.42s cubic-bezier(0.22, 0.84, 0.28, 1), opacity 0.26s ease,
    box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 24px;
  pointer-events: none;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  will-change: transform, opacity;
  backface-visibility: hidden;
  perspective: 1000px;
}

.mobile-menu-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(120% 60% at 100% 0%, rgba(255, 255, 255, 0.12), transparent 62%);
  opacity: 1;
  pointer-events: none;
}

.mobile-menu-panel--open {
  transform: translate3d(0, 0, 0);
  pointer-events: auto;
  box-shadow: -12px 0 28px rgba(0, 0, 0, 0.36);
  opacity: 1;
}

.mobile-menu__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu__title {
  font-size: 22px;
  font-family: 'SourceHanSerifCN-SemiBold', serif;
}

.mobile-menu__close {
  background: transparent;
  border: none;
  color: #fde0d9;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
}

.mobile-menu__search {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(253, 200, 200, 0.35);
  border-radius: 999px;
  padding: 8px 16px;
}

.mobile-menu__search input {
  flex: 1;
  border: none;
  background: transparent;
  color: #fff5f2;
  font-size: 15px;
}

.mobile-menu__search input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}

.mobile-menu__search input:focus {
  outline: none;
}

.mobile-menu__search button {
  background: #c24c4c;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-menu__search img {
  width: 16px;
  height: 16px;
}

.mobile-menu__nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mobile-menu__nav-item {
  width: 100%;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  color: #fff8f1;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 12px;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'STSongti-SC-Bold', serif;
  opacity: 0;
  transform: translate3d(22px, 0, 0);
  will-change: transform, opacity;
  transition: opacity 0.24s ease, transform 0.34s cubic-bezier(0.2, 0.78, 0.24, 1),
    background-color 0.2s ease;
}

.mobile-menu__nav-item img {
  width: 14px;
  height: 14px;
}

.mobile-menu-panel--open .mobile-menu__nav-item {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(1) {
  transition-delay: 0.04s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(2) {
  transition-delay: 0.08s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(3) {
  transition-delay: 0.12s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(4) {
  transition-delay: 0.16s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(5) {
  transition-delay: 0.2s;
}

@media (prefers-reduced-motion: reduce) {
  .mobile-menu-panel,
  .mobile-menu-mask,
  .mobile-menu__nav-item {
    transition: none !important;
    transition-delay: 0s !important;
  }
}

@media (min-width: 641px) {
  .site-header {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
  }
}

@media (max-width: 1024px) {
  .site-header {
    grid-template-columns: 1fr auto;
    text-align: left;
    padding: 20px 24px;
    row-gap: 0;
  }
  .main-nav {
    display: none;
  }
  .search-panel {
    display: none;
  }
  .mobile-menu-toggle {
    display: inline-flex;
    justify-self: end;
    border: none;
    background: rgba(255, 255, 255, 0.08);
    padding: 6px 10px;
    border-radius: 6px;
    box-shadow: none;
  }
}

@media (max-width: 640px) {
  .site-header {
    padding: 20px 12px;
    grid-template-columns: 1fr auto;
  }
  .site-logo {
    font-size: 26px;
  }
  .mobile-menu-toggle {
    width: 40px;
    height: 40px;
    padding: 6px;
  }
  .mobile-menu-panel {
    width: 100vw;
    max-width: none;
  }
}
</style>
